import { supabase } from '@/lib/supabase';
import { JournalExportError } from './buildJournalExportPackage';

export async function fetchJournalAttachmentBytes(documentId: string): Promise<Uint8Array> {
  const { data, error } = await supabase.rpc('get_document_download_url', {
    p_document_id: documentId,
  });
  if (error || data == null) {
    throw new JournalExportError(
      'attachment_missing',
      'Journal attachment could not be retrieved',
      {
        cause: error,
      },
    );
  }

  const result = data as { storage_path?: string };
  if (!result.storage_path) {
    throw new JournalExportError('attachment_missing', 'Journal attachment could not be retrieved');
  }

  const { data: signed, error: signedError } = await supabase.storage
    .from('patient-documents')
    .createSignedUrl(result.storage_path, 60);
  if (signedError || !signed?.signedUrl) {
    throw new JournalExportError(
      'attachment_missing',
      'Journal attachment could not be retrieved',
      {
        cause: signedError,
      },
    );
  }

  const response = await fetch(signed.signedUrl);
  if (!response.ok) {
    throw new JournalExportError('attachment_missing', 'Journal attachment could not be retrieved');
  }

  return new Uint8Array(await response.arrayBuffer());
}
